import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { environment } from "../../../../../environments/environment";
import { RequestPasswordCommand } from "../models/command/RequestPasswordCommand";
import { RequestTokenService } from "../../../../../services/request-token.service";
import { UpdatePasswordCommand } from "../models/command/UpdatePasswordCommand";

const API_URL = `${environment.apiUrl}v1/Account`;

@Injectable({
  providedIn: 'root'
})

export class AccountService {

  constructor(private http: HttpClient,
    private requestToken: RequestTokenService
  ) {}

  private handleError(error: any): Observable<never> {
    console.error('An error occurred', error);
    return throwError(error);
  }
  
  public ConfirmeCodigo(command: RequestPasswordCommand): Observable<any>{
    // Usar XMLHttpRequest diretamente para evitar interceptação do Nebular
    return new Observable(observer => {
      const xhr = new XMLHttpRequest();
      const url = `${environment.apiUrl}v1/Account/confirme-codigo`;
      
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      
      // Adicionar headers de autorização se necessário
      const authHeaders = this.requestToken.createAuthorizationHeader();
      if (authHeaders) {
        Object.keys(authHeaders).forEach(key => {
          xhr.setRequestHeader(key, authHeaders[key]);
        });
      }
      
      xhr.withCredentials = true;
      
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const response = JSON.parse(xhr.responseText);
            observer.next(response);
            observer.complete();
          } catch (e) {
            observer.error(new Error('Invalid JSON response'));
          }
        } else {
          observer.error(new Error(`HTTP ${xhr.status}: ${xhr.statusText}`));
        }
      };
      
      xhr.onerror = function() {
        observer.error(new Error('Network error'));
      };
      
      xhr.send(JSON.stringify(command));
    });
  }

  public AtualizaSenha(command: UpdatePasswordCommand): Observable<any>{
    // Usar XMLHttpRequest diretamente para evitar interceptação do Nebular
    return new Observable(observer => {
      const xhr = new XMLHttpRequest();
      const url = `${environment.apiUrl}v1/Account/atualiza-senha`;
      
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      
      // Adicionar headers de autorização se necessário
      const authHeaders = this.requestToken.createAuthorizationHeader();
      if (authHeaders) {
        Object.keys(authHeaders).forEach(key => {
          xhr.setRequestHeader(key, authHeaders[key]);
        });
      }
      
      xhr.withCredentials = true;
      
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const response = JSON.parse(xhr.responseText);
            observer.next(response);
            observer.complete();
          } catch (e) {
            observer.error(new Error('Invalid JSON response'));
          }
        } else {
          observer.error(new Error(`HTTP ${xhr.status}: ${xhr.statusText}`));
        }
      };
      
      xhr.onerror = function() {
        observer.error(new Error('Network error'));
      };
      
      xhr.send(JSON.stringify(command));
    });
  }
}
